<template>
	<div class="shiting-container">
		<div class="inner-container">
			<!-- Left Content: Shiting -->
			<div v-if="currentView === 'Shiting'" class="shiting-content-wrapper">
				<div class="main-content">
					<div class="page-title">试听</div>
					
					<div class="section">
						<div class="section-title">
							<span class="step-num">1</span>
							<span class="step-text">操作提示</span>
						</div>
						<div class="section-content instruction-box">
							<div class="instruction-img">
								<img src="@/assets/svg/headphone_instruction.svg" alt="Headphone Instruction" />
							</div>
							<div class="instruction-text">
								请按图示方法佩戴耳机，并通过右下角音量调节按键调整至合适的音量大小。
							</div>
						</div>
					</div>
					
					<div class="section">
						<div class="section-title">
							<span class="step-num">2</span>
							<span class="step-text">测试音频</span>
						</div>
						<div class="section-content">
							<div class="test-hint">
								如能清晰听到声音，请点击 <span class="btn-mock">清 晰</span> ；若一直不清晰请联系监考老师更换设备。
							</div>
							<div class="audio-text-box">
								<p>生活就像海洋，只有意志坚强的人，才能到达彼岸。</p>
								<p class="en-text">This is an apple. I like apples. Apples are good for our health.</p>
							</div>
							<div class="action-buttons">
								<el-button type="primary" class="btn-clear" @click="handleClear">清 晰</el-button>
								<el-button :type="isPlaying ? 'danger' : 'success'" class="btn-play" @click="playAudio">{{ isPlaying ? '停止播放' : '播放试音' }}</el-button>
							</div>
						</div>
					</div>
				</div>

				<!-- Dialog -->
				<el-dialog title="提示" :visible.sync="dialogVisible" width="440px" center :show-close="false"
					custom-class="custom-dialog" :append-to-body="true">
					<div slot="title" class="dialog-title">
						<img src="@/assets/svg/warning_icon.svg" alt="warning" class="warning-icon" /> 提示
					</div>
					<div class="dialog-content">
						<p class="warning-text">请确定您的放音音量大小是否调整至合适位置？</p>
						<p class="sub-text">点击[确定]完成试听，等待考试正式开始</p>
						<p class="sub-text">点击[取消]可返回重新试听</p>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="handleCancel">取 消</el-button>
						<el-button type="primary" @click="handleConfirm">确 定</el-button>
					</span>
				</el-dialog>
			</div>

			<!-- Left Content: Zhuyishixiang -->
			<div v-if="currentView === 'Zhuyishixiang'" class="zhuyishixiang-container">
				<div class="content-wrapper">
					<div class="notice-box">
						<div class="notice-title">注意事项</div>
						<div class="notice-content">
							<p>1.听力考试由A、B两套试卷组成，每套试卷各20小题，满分均为30分。考生须依次完成两套试卷作答。</p>
							<p>2.注意，回答听力部分时，可以将答案记录在草稿纸上，每套试卷听力播放全部结束后，你将有2分钟的时间将你的答案录入计算机，并进行确认和修改。</p>
							<p>3.听力考试过程中，如出现播放不清、设备故障等，请立即举手向工作人员示意。</p>
						</div>
						<div class="notice-footer">
							祝各位考生考试顺利！
						</div>
					</div>
				</div>
				
				<div class="bottom-bar">
					<div class="status-indicator">
						<span class="dot"></span>
						<span class="status-text">听指令</span>
					</div>
					<div class="dotted-line"></div>
				</div>
			</div>
			
			<!-- Right Sidebar -->
			<div class="sidebar">
				<div class="sidebar-header">
					<div class="header-item">
						<div class="label">考 生</div>
						<div class="value-box">
							<!-- Placeholder for avatar -->
							<img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar-img" />
							<div v-else class="avatar-placeholder">
								<i class="el-icon-user-solid"></i>
							</div>
						</div>
					</div>
					<div class="header-item">
						<div class="label">机 位</div>
						<div class="value-box seat-num">
							{{ seatNumber }}
						</div>
					</div>
				</div>
				
				<div class="user-info">
					<div class="info-group">
						<div class="info-label">姓名</div>
						<div class="info-value name">{{ userInfo.name }}</div>
					</div>
					<div class="info-group">
						<div class="info-label">准考证号</div>
						<div class="info-value ticket">{{ userInfo.ticketNumber }}</div>
					</div>
				</div>
				
				<div class="volume-control">
					<div class="volume-label">音量调节</div>
					<div class="slider-wrapper">
						<img src="@/assets/svg/volume_icon.svg" alt="volume" class="volume-icon" />
						<el-slider v-model="volume" :min="0" :max="100" @change="handleVolumeChange"></el-slider>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'shiting',
	data() {
		return {
			currentView: 'Shiting',
			seatNumber: 50,
			userInfo: {
				name: '夏老师',
				ticketNumber: '15256558239',
				avatar: '' 
			},
			volume: 50,
			audio: null,
			// Shiting data
			isPlaying: false,
			dialogVisible: false
		};
	},
	mounted() {
	},
	methods: {
		handleVolumeChange(val) {
			console.log('Volume changed:', val);
		},
		handleFinish() {
			this.currentView = 'Zhuyishixiang';
			// Auto navigate to jikao page after 5 seconds
			let countdown = 5;
			const timer = setInterval(() => {
				countdown--;
				if (countdown <= 0) {
					clearInterval(timer);
					this.$router.push('/jikao');
				}
			}, 1000);
		},
		// Shiting methods
		handleClear() {
			this.dialogVisible = true;
		},
		handleConfirm() {
			this.dialogVisible = false;
			this.$message.success('设备调试完成，准备开始考试');
			this.handleFinish();
		},
		handleCancel() {
			this.dialogVisible = false;
		},
		playAudio() {
			this.isPlaying = !this.isPlaying;
			if (this.isPlaying) {
				this.$message.info('开始播放试音...');
			} else {
				this.$message.info('停止播放试音');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.shiting-container {
	display: flex;
	justify-content: center;
	height: 100vh;
	background-color: #f0f2f5;

	.inner-container {
		display: flex;
		width: 1200px;
		height: 100%;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0,0,0,0.05);
	}

	.sidebar {
		width: 300px;
		background-color: #e6f3ff;
		padding: 40px 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.sidebar-header {
			display: flex;
			justify-content: space-between;
			margin-bottom: 30px;

			.header-item {
				flex: 1;
				text-align: center;

				.label {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 10px;
					color: #333;
				}

				.value-box {
					background-color: #fff;
					border: 1px solid #dcdfe6;
					height: 80px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 0 5px;

					&.seat-num {
						font-size: 36px;
						color: #0080ff;
						font-weight: bold;
					}

					.avatar-img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.avatar-placeholder {
						font-size: 40px;
						color: #ccc;
					}
				}
			}
		}

		.user-info {
			margin-bottom: auto;
			padding: 0 10px;

			.info-group {
				margin-bottom: 20px;

				.info-label {
					font-size: 14px;
					color: #666;
					margin-bottom: 5px;
				}

				.info-value {
					font-size: 16px;
					color: #0080ff;
					font-weight: bold;

					&.ticket {
						font-family: Arial, sans-serif;
					}
				}
			}
		}

		.volume-control {
			border-top: 1px solid #d0e0f0;
			padding-top: 20px;

			.volume-label {
				text-align: center;
				color: #666;
				margin-bottom: 15px;
			}

			.slider-wrapper {
				display: flex;
				align-items: center;
				padding: 0 10px;

				.volume-icon {
					font-size: 24px;
					margin-right: 15px;
					color: #333;
					width: 30px;
					height: 30px;
				}

				.el-slider {
					flex: 1;
				}
			}
		}
	}
}

/* Shiting Styles */
.shiting-content-wrapper {
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.main-content {
	flex: 1;
	padding: 40px 60px;
	overflow-y: auto;

	.page-title {
		font-size: 24px;
		font-weight: bold;
		color: #0080ff;
		margin-bottom: 30px;
	}

	.section {
		margin-bottom: 40px;

		.section-title {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			.step-num {
				background-color: #0080ff;
				color: #fff;
				width: 24px;
				height: 24px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				margin-right: 10px;
			}

			.step-text {
				font-size: 18px;
				font-weight: bold;
				color: #333;
			}
		}

		.section-content {
			margin-left: 34px;

			&.instruction-box {
				background-color: #f0faff;
				border-radius: 10px;
				padding: 40px;
				text-align: center;

				.instruction-img {
					margin-bottom: 20px;

					img {
						max-width: 100%;
						height: auto;
					}
				}

				.instruction-text {
					color: #666;
					font-size: 14px;
				}
			}

			.test-hint {
				font-size: 14px;
				color: #333;
				margin-bottom: 20px;

				.btn-mock {
					display: inline-block;
					padding: 2px 8px;
					border: 1px solid #ccc;
					border-radius: 4px;
					font-size: 12px;
					margin: 0 4px;
					background-color: #f9f9f9;
				}
			}

			.audio-text-box {
				background-color: #f0faff;
				border-radius: 8px;
				padding: 20px;
				margin-bottom: 30px;

				p {
					margin: 10px 0;
					color: #666;
					font-size: 16px;

					&.en-text {
						font-family: Arial, sans-serif;
					}
				}
			}

			.action-buttons {
				text-align: center;

				.el-button {
					width: 120px;
					margin: 0 15px;
				}
			}
		}
	}
}

/* Zhuyishixiang Styles */
.zhuyishixiang-container {
	flex: 1;
	display: flex;
	flex-direction: column;
	background-color: #fff;
	position: relative;
	height: 100%;
}

.content-wrapper {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px;
}

.notice-box {
	background-color: #f0faff;
	border-radius: 10px;
	padding: 40px 60px;
	width: 100%;
	max-width: 800px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	text-align: center;

	.notice-title {
		color: #f56c6c;
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 30px;
		letter-spacing: 2px;
	}

	.notice-content {
		text-align: left;
		margin-bottom: 30px;

		p {
			color: #409EFF;
			font-size: 16px;
			line-height: 1.8;
			margin-bottom: 15px;
			text-indent: 0;
		}
	}

	.notice-footer {
		color: #409EFF;
		font-size: 20px;
		font-weight: bold;
		letter-spacing: 1px;
	}
}

.bottom-bar {
	height: 60px;
	background-color: #0080ff;
	display: flex;
	align-items: center;
	padding: 0 30px;
	color: #fff;

	.status-indicator {
		display: flex;
		align-items: center;
		margin-right: 20px;
		flex-shrink: 0;

		.dot {
			width: 10px;
			height: 10px;
			background-color: #67c23a;
			border-radius: 50%;
			margin-right: 10px;
			box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
		}

		.status-text {
			font-size: 18px;
			font-weight: bold;
		}
	}

	.dotted-line {
		flex: 1;
		height: 0;
		border-bottom: 2px dotted rgba(255, 255, 255, 0.6);
		margin-top: 5px; 
	}
}
</style>

<style lang="scss">
.custom-dialog {
	.el-dialog__header {
		padding: 20px 20px 10px;
	}

	.dialog-title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		font-weight: bold;
		color: #333;
		
		.warning-icon {
			width: 20px;
			height: 20px;
			margin-right: 5px;
		}
	}

	.dialog-content {
		text-align: left;
		padding: 10px 20px;

		.warning-text {
			color: #f56c6c;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 15px;

		}

		.sub-text {
			color: #999;
			font-size: 14px;
			margin-bottom: 5px;
			line-height: 1.5;
		}
	}

	.el-dialog__footer {
		padding-bottom: 30px;
		text-align: center;

		.el-button {
			padding: 10px 30px;
			margin: 0 15px;
		}
	}
}
</style>